import { render, staticRenderFns } from "./MobileTestDetails.vue?vue&type=template&id=4b7398ff&scoped=true&"
import script from "./MobileTestDetails.vue?vue&type=script&lang=js&"
export * from "./MobileTestDetails.vue?vue&type=script&lang=js&"
import style0 from "./MobileTestDetails.vue?vue&type=style&index=0&id=4b7398ff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7398ff",
  null
  
)

export default component.exports